import React, { memo,useCallback,useState, useEffect } from "react";
import {FormBlocks} from '../FormBlocks';
import { isSet } from '../../../../../Utils/CommonFunctions';
import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
import ReminderComponent from './ReminderComponent';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import {ReminderDisplayValue} from './ReminderComponent/ReminderFunction';
import { useParams } from 'react-router-dom';


const Reminder  = (props)=>{
  const [isReminderSelected,setReminderSelected] = useState(false);
  const [isOpenReminderPopup,setReminderPopup]   = useState(false);
  const [displayReminder,setDisplayReminder]     = useState({remind:'',repeat:''}); 

  const  {
    item,
    className,
    validationForms,
    fieldObj,
    reminderDisplayText
  } = props;
  const {reminder} = item;
  useEffect(()=>{
    try{
      if(isSet(reminder,null)!==null){
        if(reminder.is_active === true){
        if(isSet(reminder.remind_time,null) !==null){
          setDisplayReminder(ReminderDisplayValue(reminder));
          setReminderSelected(true);
        }
      }
      }else{
        resetLocalState();
      }
    }catch(e){
      resetLocalState();
    }
  },[]);

//  useEffect(()=>{
//   setDisplayReminder({remind:'',repeat:''});
//  },[isReminderSelected])  

  //RESET LOCAL STATE
  const resetLocalState = useCallback(()=>{
    setDisplayReminder({remind:'',repeat:''});
    setReminderSelected(false);
    setReminderPopup(false);
  });

  // REMINDER POPUP SUBMIT/SAVE HANDLER 
  const submitHandler = useCallback((displayMsg,reminderJson,mode)=>{
   if(mode==='REMIND'){
      props.onChangeInputAction(fieldObj,isReminderSelected ? {...reminderJson,is_active:isReminderSelected} : null,'Reminder');
      setReminderPopup(false);
      setDisplayReminder(displayMsg);
    }
  });

  //REMINDER CHECKBOX ITEM HANDLER
  const reminderChangeHandler = useCallback((boll)=>{
    //console.log('reminderChangeHandler')
    if(boll===false){
      props.onChangeInputAction(fieldObj,null,'Reminder');
    }
    setReminderPopup(boll);
    setDisplayReminder((boll===false)?'':displayReminder);
    setReminderSelected(boll);
  });

  //CLOSE REMINDER POPUP
  const closeReminderPopup = useCallback((json)=>{
    if(displayReminder.remind==='' || displayReminder.remind===undefined){
      setReminderPopup(false);
      setReminderSelected(false);
      return
    }
    setReminderPopup(false);
    setReminderSelected(true);
  });

  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);
  let readonlyVal = false;
  if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
    readonlyVal = attr.fieldAttributes.readOnly;
  }
  const params = useParams()
  //console.log('isOpenReminderPopup==',isOpenReminderPopup)
  //console.log('params.page==',params.page)
  //console.log('displayReminder==',displayReminder)
  return(
    <Wrp>
      <FormBlocks {...props} attr={attr}>
        <div className="d-flex">
	        <div className="material-switch p-2">
            <input 
              id={"selectReminder_"+item.id} 
              type="checkbox" 
              checked={(isReminderSelected===true)?true:false} 
              onChange={(params.page!=="customize" || props.screen==='Steps' || props.screen==='Approval')?()=>reminderChangeHandler(!isReminderSelected):()=>{}}/>
		        <label htmlFor={readonlyVal === false ? "selectReminder_"+item.id: null} className="secondary_bg" ></label>
		      </div>
	        <label className="badge badge-warning" onClick={readonlyVal === false ? ()=>reminderChangeHandler(true) : null}> 
	          {displayReminder.remind}
	        </label>
	      </div>
      </FormBlocks>
      {(isOpenReminderPopup===true)?
        <Wrp>
          <ReminderComponent 
            attr={attr}
            selectedValue={reminder}
            submitHandler = {submitHandler}
            reminderChangeHandler={reminderChangeHandler}
            closeReminderPopup={closeReminderPopup}
            {...props}
            isReminderSelected={isReminderSelected}
            reminderDisplayText={reminderDisplayText}
            displayReminder={displayReminder}  />
        {/* <div className="bg-overlay overlayVisible" style={{zIndex:'1100'}}></div> */}
        </Wrp>
      :<></>}
      </Wrp> 
  )
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.reminder===nextProps.item.reminder && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode){
    return true;
  }
}

Reminder.defaultProps = {
  generator: false,
  className: "form-control"
}
export default memo(Reminder,isDiffProps)


// class Reminder extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       isReminderSelected:false,
//       openReminderPopup:false,
//       displayReminder:{
//         remind:'',
//         repeat:''
//       }
//     }
//   }
//   render() {
    
//     const  {
//       item,
//       className,
//       validationForms,
//       fieldObj
//     } = this.props;

    
//     const attr = formFieldsAttributes(
//       {...item,className:className
//     },validationForms);
//     const {isReminderSelected,displayReminder,openReminderPopup } =  this.state;
//     let readonlyVal = false;
//     if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
//        readonlyVal = attr.fieldAttributes.readOnly;
//     }

//     return (
//       <Wrp>
//       <FormBlocks {...this.props} attr={attr}>
//         <div className="d-flex">
// 	        <div className="material-switch p-2">
//             <input 
//               id="selectReminder" 
//               type="checkbox" 
//               checked={(isReminderSelected===true)?true:false} 
//               onChange={this.reminderChangeHandler.bind(this,!isReminderSelected)}/>
// 		        <label htmlFor={readonlyVal === false ? "selectReminder": null} className="secondary_bg" ></label>
// 		      </div>
// 	        <label className="badge badge-warning" onClick={readonlyVal === false ? this.reminderChangeHandler.bind(this,true) : null}> 
// 	          {displayReminder.remind} 
//             {/* <i className="fa fa-repeat ml-3" aria-hidden="true"></i>
//               {displayReminder.repeat} */}
// 	        </label>
// 	      </div>
//       </FormBlocks>
//       {(openReminderPopup===true)?
//       <Wrp>
//         <ReminderComponent 
//           attr={attr}
//           selectedValue={item.reminder}
//           submitHandler = {this.submitHandler}
//           reminderChangeHandler={this.reminderChangeHandler}
//           closeReminderPopup={this.closeReminderPopup}
//           {...this.props}
//           {...this.state} />
//         {/* <div className="bg-overlay overlayVisible" style={{zIndex:'1100'}}></div> */}
//       </Wrp>
//       :''}
          
//       </Wrp>    
//     );
//   }
//   componentDidMount = ()=>{
//     const {item} = this.props;
//     // console.log(item);
//     try{
//       if(item.reminder!==null && item.reminder!==''){
//         if(typeof item.reminder.remind_time != "undefined" && item.reminder.remind_time!==''){
//           const reminderJson = item.reminder;
//           const displayMsg = ReminderDisplayValue(reminderJson);
          
//           this.setState({displayReminder:displayMsg,isReminderSelected:true});
//         }
//       }else{
//         this.setState({
//           isReminderSelected:false,
//           openReminderPopup:false,
//           displayReminder:{
//             remind:'',
//             repeat:''
//           },isReminderSelected:false
//         });
//       }
//     }catch(e){
//       this.setState({
//         isReminderSelected:false,
//         openReminderPopup:false,
//         displayReminder:{
//           remind:'',
//           repeat:''
//         },isReminderSelected:false
//       });
//     }
    
//   }
//   submitHandler = (displayMsg,reminderJson,mode)=>{
//     const  {item,section} = this.props;
//     const {isReminderSelected} = this.state;
//     const updateData = {
//       section_index:section.section_index,
//       itemIndex:item.itemIndex,
//       item:item,
//       ...this.props.subformObj
//     }
//     // console.log(JSON.stringify(reminderJson),mode);
//     if(mode==='REMIND'){
//       // reminderJson = {"remind_on":0,"remind_period":"","remind_date":"2020-12-31","remind_time":"23:00","repeat_type":4,"repeat_frequency":0,"repeat_every":1,"repeat_weekday":1,"repeat_dom":"","repeat_weekseq":0,"repeat_month":0,"repeat_ends":"On 2021-01-20","remind_alert":1,"start_date":"2020-12-28","start_time":"13:12","repeatOption":"DAY","remindOption":"DAY","display_text":["a90f38dc-e59a-4a75-a898-290f894b1532","aff55b0b-d2e4-4677-8574-75ab916fce32"]};
//       this.props.onChangeInputAction(updateData,{...reminderJson,is_active:isReminderSelected},'Reminder');
//       this.setState({openReminderPopup:false});
//     }
//     this.setState({displayReminder:displayMsg});
//   }
//   reminderChangeHandler = (boll)=>{
//     if(boll===false){
//       const  {item,section} = this.props;
//       const updateData = {
//         section_index:section.section_index,
//         itemIndex:item.itemIndex,
//         item:item,
//         ...this.props.subformObj
//       }
//       this.props.onChangeInputAction(updateData,{...item.reminder,is_active:boll},'Reminder');
//     }
//     this.setState({
//       isReminderSelected:boll,
//       openReminderPopup:boll,
//       displayReminder:(boll===false)?'':this.state.displayReminder
//     });
    
//   }
//   closeReminderPopup = (json)=>{
//     let isReminderSelected = null;
//     if(json.remind_time===''){
//       isReminderSelected = false;
//     }else{
//       isReminderSelected = true;
//     }
//     this.setState({openReminderPopup:false,isReminderSelected:isReminderSelected});
//   }
// }

